import {
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from 'antd';
import { Rule } from 'antd/es/form';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import iconArrive from '../../assets/images/booking/icon-arrive.svg';
import iconDepart from '../../assets/images/booking/icon-depart.svg';
import iconDown from '../../assets/images/booking/icon-down.svg';
import iconEmail from '../../assets/images/booking/icon-mail.svg';
import iconName from '../../assets/images/booking/icon-name.svg';
import iconPhone from '../../assets/images/booking/icon-phone.svg';
import iconBookingAgent from '../../assets/images/ic-booking-agent.svg';
import iconCancelPinCode from '../../assets/images/ic-cancel-pincode.svg';
import iconNumpad from '../../assets/images/ic-numpad.svg';
import '../../assets/styles/desktop/busBooking.scss';
import ModalInfoInsurance from '../../components/Modal/ModalInfoInsurance';
import ModalNumpad from '../../components/Modal/ModalNumpad';
import { Toast, USER_GROUP } from '../../config/constant';
import { convertTimeFormat, filterOption, filterOptionAgent, formattedPrice, getPaymentMethod, getSeatTypeBooking } from '../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { listAgentSelector } from '../../redux/slice/agents/listAgentSlice';
import { selectAuth } from '../../redux/slice/authSlice';
import { getCheckBookingV2 } from '../../redux/slice/bookings/checkBookingSlice';
import { createBookingSelector, setPinCode } from '../../redux/slice/bookings/createBookingSlice';
import { listBookingSelector } from '../../redux/slice/bookings/listBooking';
import { setToast } from '../../redux/slice/toastNotifySlice';
import {
  agentBalanceOption,
  bankAgentOption,
  bankOption,
  cashAgentOption,
  cashOption,
  paymentAgentOptions,
  paymentMultiOptions,
  paymentOptions,
  paymentPaidCompanyOptions,
  validatorEmailBooking,
} from '../../utils/bookingItem';
import { getPriceScheduleReason } from '../../utils/helpers';

const ModalBooking1: React.FC<any> = ({
  listBooking,
  isDetail,
  listBookingDetail,
  formBooking,
  isListTicket,
  dataCustomerBooking,
  openModalNumpad,
  setOpenModalNumpad,
  dataBooking,
  listLocationDepart,
  setListLocationDepart,
  listLocationArrive,
  setListLocationArrive,
  searchDateBooking,
  segmentDepartTime,
  setSegmentDepartTime,
  segmentArriveTime,
  setSegmentArriveTime,
}) => {
  const { t } = useTranslation();
  const { listCustomers, errorDetail: errorCreate, statusPin, pin_code, price } = useAppSelector(createBookingSelector);
  const { listDataSegmentBooking } = useAppSelector((state) => state.checkBooking);
  const { loadingListBookingDetail } = useAppSelector(listBookingSelector);
  const { group } = useAppSelector(selectAuth);
  const { listAgentActive } = useAppSelector(listAgentSelector);
  const [otp, setOtp] = useState<string>('');
  const dispatch = useAppDispatch();
  const [paymentMethod, setPaymentMethod] = useState(undefined);
  const [customerPhone, setCustomerPhone] = useState<string>('');
  const [openModalInfo, setOpenModalInfo] = useState<boolean>(false);
  const [isChangeSegment, setIsChangeSegment] = useState<boolean>(false);
  const isInSurance = Form.useWatch('is_insurance', formBooking);
  const pickUpValue = Form.useWatch('pickup_location_id', formBooking);
  const dropOffValue = Form.useWatch('drop_off_location_id', formBooking);
  const isAgentId = Form.useWatch('is_agent_id', formBooking);
  const agentId = Form.useWatch('agent_id', formBooking);
  const segmentId = Form.useWatch('segment_id', formBooking);
  const commisionPrice = Form.useWatch('commission_price', formBooking);
  const [commissionPrice, setCommissionPrice] = useState(0);

  // const onChangeInsurance = () => {};
  const onChangePayment = ({ target: { value } }: RadioChangeEvent) => {
    setPaymentMethod(value);
  };
  const NameRules: Rule[] = [
    {
      required: true,
      message: t('Vui lòng nhập tên'),
    },
    {
      pattern: /^[^\s].*$/,
      message: t('Tên không được chứa chỉ khoảng trắng'),
    },
  ];
  const handleOptionPickup = () => {
    let options: any = [];
    if (listLocationDepart?.length) {
      options = options.concat(
        listLocationDepart?.length
          ? listLocationDepart?.map((item: any) => {
              return {
                value: item.id,
                label: `(${convertTimeFormat(item?.pickup_time)}) ${item?.pickup_location_name}`,
              };
            })
          : [],
      );
    }
    if (
      listBooking?.schedule?.is_depart_transship ||
      listBooking?.contract?.code ||
      dataCustomerBooking?.is_depart_transship
    ) {
      options.push({
        value: 'other',
        label: 'Nhập điểm trung chuyển khác',
      });
    }
    return options;
  };
  const groupSeatOption = () => {
    return listBooking?.schedule?.bus_type?.seat_map?.group_seat?.length
      ? listBooking?.schedule?.bus_type?.seat_map?.group_seat?.map((item: any) => {
          return {
            value: item?.name,
            label: item?.name,
          };
        })
      : [];
  };
  const onFillCustomer = (value: string) => {
    if (listCustomers?.length) {
      const selectedCustomer = listCustomers?.find((customer: any) => customer.phone === value);
      if (selectedCustomer) {
        formBooking.setFieldsValue({
          customer_name: selectedCustomer.name,
          customer_email: selectedCustomer.email,
          customer_phone: selectedCustomer.phone,
        });
      }
    }
  };
  const onChangePhone = (keyword: any) => {
    onFillCustomer(keyword);
  };
  const handleInputChange = (value: string) => {
    setCustomerPhone(value);
  };
  const handleOptionDropOff = () => {
    let options: any = [];
    if (listLocationArrive?.length) {
      options = options.concat(
        listLocationArrive?.length
          ? listLocationArrive?.map((item: any) => {
              return {
                value: item.id,
                label: `(${convertTimeFormat(item?.pickup_time)}) ${item?.pickup_location_name}`,
              };
            })
          : [],
      );
    }
    if (
      listBooking?.schedule?.is_arrive_transship ||
      listBooking?.contract?.code ||
      dataCustomerBooking?.is_arrive_transship
    ) {
      options.push({
        value: 'other',
        label: 'Nhập điểm trung chuyển khác',
      });
    }
    return options;
  };
  const listSegmentOption = listDataSegmentBooking?.length
    ? [
        ...listDataSegmentBooking.map((item: any) => ({
          value: item?.segment_id,
          label: `${item?.start_location?.name} - ${item?.end_location?.name}`,
          transship_depart: item?.transship_depart,
          transship_arrive: item?.transship_arrive,
          time: item?.time,
          available_seats: item?.available_seats,
          price_schedule: item?.price_schedule,
        })),
        ...(listBookingDetail?.segment_id && pin_code
          ? [
              {
                value: listBookingDetail.segment_id,
                label: (
                  <div className="d-flex items-center gap-x-2">{`${listBookingDetail?.start_location} - ${listBookingDetail?.end_location}`}</div>
                ),
              },
            ]
          : []),
      ]
    : listBookingDetail?.segment_id
    ? [
        {
          value: listBookingDetail.segment_id,
          label: (
            <div className="d-flex items-center gap-x-2">{`${listBookingDetail?.start_location} - ${listBookingDetail?.end_location}`}</div>
          ),
        },
      ]
    : [];
  const listAgentActiveOption = listAgentActive?.length
    ? listAgentActive?.map((item: any) => {
        return {
          commission_percent: item?.commission_percent,
          value: item?.id,
          label: (
            <div className="d-flex items-center gap-x-2">
              <img src={iconBookingAgent} alt="" />
              {item?.name}
            </div>
          ),
          searchText: item?.name?.toLowerCase() || '',
        };
      })
    : [];

  useEffect(() => {
    if (errorCreate) {
      Object.keys(errorCreate).forEach((fieldName) => {
        const errorMessage = errorCreate[fieldName][0];
        dispatch(
          setToast({
            message: errorMessage,
            status: true,
            type: Toast.TYPE_ERROR,
          }),
        );
      });
    }
  }, [errorCreate, formBooking, dispatch]);

  const onChangeIsAgent = () => {
    if (
      !(
        listBookingDetail?.orderer?.company?.id ||
        listBookingDetail?.payer?.agent?.id ||
        listBookingDetail?.source === 'openapi' ||
        listBookingDetail?.source === 'company' ||
        (listBookingDetail?.orderer?.agent?.id && !listBookingDetail?.booking_for_agent)
      )
    ) {
      const currentChecked = formBooking.getFieldValue('is_agent_id');
      formBooking.setFieldsValue({ is_agent_id: !currentChecked });
    }
  };
  const getPaymentOptions = () => {
    const { payment_method } = listBookingDetail || {};
    if (group !== USER_GROUP.AGENT) {
      switch (payment_method) {
        case 'bank_transfer':
          return bankOption;
        case 'cash':
          return cashOption;
        default:
          break;
      }
    }
    if (group === USER_GROUP.AGENT) {
      switch (payment_method) {
        case 'paid_at_company':
        case 'reverse':
          return paymentAgentOptions;
        case 'agent_balance':
          return agentBalanceOption;
        case 'bank_transfer':
          return bankAgentOption;
        case 'cash':
          return cashAgentOption;
        default:
          return paymentAgentOptions;
      }
    }
    if (isDetail) {
      switch (payment_method) {
        case 'paid_at_company':
        case 'reverse':
          return paymentPaidCompanyOptions;
        case 'agent_balance':
          return agentBalanceOption;
        case 'cash':
          return cashOption;
        case 'bank_transfer':
          return bankOption;
        default:
          return paymentOptions;
      }
    }

    return paymentMultiOptions;
  };

  const handleChangeAgentIdOption = (option: any) => {
    setCommissionPrice(option?.commission_percent);
  };
  const handleChangeSegment = (value: any, option: any) => {
    setListLocationDepart(option?.transship_depart?.length > 0 ? option?.transship_depart : []);
    setListLocationArrive(option?.transship_arrive?.length > 0 ? option?.transship_arrive : []);
    setSegmentDepartTime(option?.time?.depart_datetime);
    setSegmentArriveTime(option?.time?.arrive_datetime);
    if (isDetail && listBookingDetail?.id && pin_code && +value !== +listBookingDetail?.segment_id) {
      formBooking.setFieldsValue({
        pickup_location_id: undefined,
        drop_off_location_id: undefined,
        pickup_extra: undefined,
        drop_off_extra: undefined,
      });
    }
  };
  const handleNumpadClick = (isSegment: boolean) => {
    setIsChangeSegment(isSegment);
    if (pin_code) {
      dispatch(setPinCode(null));
    } else {
      setOtp('');
      setOpenModalNumpad(true);
    }
  };
  const getPayerBooking = () => {
    if (listBookingDetail?.ticket_code) {
      if (listBookingDetail?.payer?.company?.id) {
        return (
          <p className="fs-14 fw-500 text-blue pb-2">{`${listBookingDetail?.payer?.name} - ${
            listBookingDetail?.payer?.office_name
          } đã thu bằng ${
            listBookingDetail?.payment_method === 'cash'
              ? 'tiền mặt'
              : listBookingDetail?.payment_method === 'bank_transfer'
              ? 'chuyển khoản'
              : 'tài khoản đại lý'
          } ${listBookingDetail?.price_change ?? listBookingDetail?.final_price}`}</p>
        );
      }
      if (listBookingDetail?.payer?.agent?.id) {
        return (
          <p className="fs-14 fw-500 text-blue pb-2">{`${listBookingDetail?.payer?.agent?.name} đã thu bằng ${
            listBookingDetail?.payment_method === 'cash'
              ? 'tiền mặt'
              : listBookingDetail?.payment_method === 'bank_transfer'
              ? 'chuyển khoản'
              : 'tài khoản đại lý'
          } ${listBookingDetail?.price_change ?? listBookingDetail?.final_price}`}</p>
        );
      }
      if (listBookingDetail?.is_driver_pay) {
        <p className="fs-14 fw-500 text-blue pb-2">
          {`Tài xế đã thu bằng ${getPaymentMethod(listBookingDetail?.payment_method)} ${
            listBookingDetail?.commission_price ? formattedPrice(listBookingDetail?.commission_price) : 0
          }VNĐ `}
        </p>;
      }
    }
  };
  const options = getPaymentOptions();
  useEffect(() => {
    if (statusPin) {
      setOpenModalNumpad(false);
    }
  }, [statusPin]);

  useEffect(() => {
    if ((!pin_code || !listBookingDetail?.price_change) && commisionPrice) {
      formBooking.setFieldValue('commission_price_change', commisionPrice);
    } else {
      if (listBookingDetail?.price_change) {
        formBooking.setFieldValue('commission_price_change', listBookingDetail?.price_change);
      } else {
        if (agentId && isAgentId) {
          formBooking.setFieldValue('commission_price_change', price?.commission_price);
        }
      }
    }
  }, [pin_code, listBookingDetail, commisionPrice, agentId, isAgentId, price]);
  useEffect(() => {
    if (isDetail && pin_code && listBookingDetail?.seat_number) {
      const checkBookingData = {
        schedule_id: +listBooking?.schedule?.id,
        seat_number: [listBookingDetail?.seat_number],
        depart_date: searchDateBooking,
        is_diagram: listBooking?.schedule?.is_diagram,
      };
      dispatch(getCheckBookingV2(checkBookingData));
    }
  }, [isDetail, pin_code, listBookingDetail]);

  return (
    <Spin spinning={loadingListBookingDetail}>
      <div className="segment-booking-block mt-3">
        <div className="bg-segment">
          <span>Chọn chặng</span>
        </div>
        <Row gutter={16}>
          <Col span={16}>
            <Flex className="block-numpad-input segment">
              <Form.Item
                name="segment_id"
                className="form-item-name require w-90"
                validateTrigger={['onChange', 'onBlur']}
              >
                <Select
                  className={`input-h40 w-100 ${isDetail ? 'is_detail' : ''}`}
                  placeholder="Chọn chặng"
                  size="large"
                  options={[...listSegmentOption]}
                  showSearch
                  disabled={isDetail ? !pin_code : false}
                  filterOption={filterOption}
                  optionRender={(option) => (
                    <>
                      <Space className="w-100 fw-500 text-color-default d-flex justify-between">
                        <div>
                          {`${option?.data?.label}`}
                          {option?.data?.price_schedule?.reason ? (
                            <div className="text-success fs-13 fw-500">
                              {getPriceScheduleReason(option?.data?.price_schedule, false)}
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                        <div className="available-seat-segment">{`Còn ${option?.data?.available_seats} chỗ`}</div>
                      </Space>
                    </>
                  )}
                  value
                  suffixIcon={<img src={iconDown} alt="" />}
                  onChange={(value, option) => handleChangeSegment(value, option)}
                />
              </Form.Item>
              {group !== USER_GROUP.AGENT ? (
                <div className="btn-numpad" onClick={() => handleNumpadClick(true)} style={{ marginTop: 0 }}>
                  <img src={pin_code ? iconCancelPinCode : iconNumpad} alt="" />
                </div>
              ) : (
                ''
              )}
            </Flex>
            {segmentDepartTime && segmentArriveTime ? (
              <Flex className="mt-2" gap={20}>
                <p className="fs-14 fw-500 text-blue">
                  Thời gian đi: <span className="fw-600 fs-14">{segmentDepartTime}</span>
                </p>
                <p className="fs-14 fw-500 text-blue">
                  Thời gian đến: <span className="fw-600 fs-14">{segmentArriveTime}</span>
                </p>
              </Flex>
            ) : (
              ''
            )}
          </Col>
          <Col span={8}>
            {group === USER_GROUP.CAR_COMPANY && listBookingDetail?.source !== 'company' ? (
              <div className="agent-booking-block">
                <div
                  onClick={onChangeIsAgent}
                  className={`${listBookingDetail?.payer?.agent?.id ? 'cursor-not-allow' : 'cursor-pointer'} h-fit`}
                >
                  <Form.Item
                    name="is_agent_id"
                    className="is-agent d-flex items-center justify-center"
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={
                        listBookingDetail?.payer?.agent?.id ||
                        (listBookingDetail?.orderer?.agent?.id && !listBookingDetail?.booking_for_agent) ||
                        listBookingDetail?.source === 'openapi' ||
                        listBookingDetail?.source === 'company'
                      }
                    />
                  </Form.Item>
                </div>
                <Form.Item name="agent_id" className="is-agent-select" required={isAgentId ? true : false}>
                  <Select
                    className="input-h36"
                    disabled={
                      !isAgentId || listBookingDetail?.source === 'openapi' || listBookingDetail?.source === 'company'
                    }
                    placeholder={
                      <div
                        className="d-flex justify-center items-center "
                        style={{ columnGap: '10px', width: '150px' }}
                      >
                        <img src={iconBookingAgent} alt="" /> Đặt hộ đại lý
                      </div>
                    }
                    size="large"
                    options={[...listAgentActiveOption]}
                    showSearch
                    onChange={(value, option) => handleChangeAgentIdOption(option)}
                    filterOption={filterOptionAgent}
                    suffixIcon={<img src={iconDown} alt="" />}
                  />
                </Form.Item>
              </div>
            ) : (
              ''
            )}
          </Col>
        </Row>
      </div>
      <div className="ticket-info-booking-block mt-4">
        <div className="bg-ticket">
          <span>{`Mã vé: ${dataBooking?.ticket_code ?? listBookingDetail?.ticket_code ?? ''} 
        ${
          dataBooking?.seat_number || listBookingDetail?.seat_number
            ? `- Ghế: ${dataBooking?.seat_number ?? listBookingDetail?.seat_number ?? ''} (${
                getSeatTypeBooking(dataBooking?.seat_type) ?? getSeatTypeBooking(listBookingDetail?.seat_type ?? '')
              })`
            : ''
        }`}</span>
        </div>
        <Form.Item name="ticket_code" className="d-none">
          <Input className="input-h40" />
        </Form.Item>
        <Row gutter={12}>
          <Col span={7}>
            <Form.Item
              name="customer_phone"
              className="require"
              validateFirst
              rules={[
                {
                  required: true,
                  min: 6,
                  max: 20,
                  message: 'Vui lòng nhập SĐT hợp lệ',
                },
              ]}
              validateTrigger={['onChange', 'onBlur']}
            >
              <Input
                className="input-h40"
                placeholder={t('Nhập số điện thoại')}
                size="large"
                addonBefore={<img src={iconPhone} alt="" />}
                value={customerPhone}
                onChange={(e) => handleInputChange(e.target.value)}
                onBlur={() => {
                  onChangePhone(customerPhone);
                }}
                onWheel={(event) => event.currentTarget.blur()}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              name="customer_name"
              className="require"
              validateTrigger={['onChange', 'onBlur']}
              rules={NameRules}
            >
              <Input placeholder="Nhập họ và tên" className="input-h40" addonBefore={<img src={iconName} alt="" />} />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item name="customer_email" validateTrigger={['onChange', 'onBlur']} rules={validatorEmailBooking}>
              <Input placeholder="Nhập email" className="input-h40" addonBefore={<img src={iconEmail} alt="" />} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="pickup_location_id"
              className="form-item-name require"
              validateTrigger={['onChange', 'onBlur']}
            >
              <Select
                className="input-h40"
                placeholder={
                  <>
                    <img src={iconDepart} alt="" style={{ marginTop: '-1px', paddingRight: 5 }} /> Chọn điểm đón
                  </>
                }
                size="large"
                style={{ width: '100%' }}
                options={handleOptionPickup()}
                disabled={!segmentId}
                showSearch
                filterOption={filterOption}
                suffixIcon={<img src={iconDown} alt="" />}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="drop_off_location_id"
              className="form-item-name require"
              validateTrigger={['onChange', 'onBlur']}
            >
              <Select
                className="input-h40"
                placeholder={
                  <>
                    <img src={iconArrive} alt="" style={{ marginTop: '-1px', paddingRight: 5 }} /> Chọn điểm trả
                  </>
                }
                size="large"
                style={{ width: '100%' }}
                options={handleOptionDropOff()}
                disabled={!segmentId}
                showSearch
                filterOption={filterOption}
                suffixIcon={<img src={iconDown} alt="" />}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} className="transship-extra">
          {pickUpValue === 'other' && (
            <Col span={12}>
              <Form.Item
                name="pickup_extra"
                className="form-item-name require"
                validateTrigger={['onChange', 'onBlur']}
              >
                <Input placeholder="Chọn điểm đón khác" size="large" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          )}
          {pickUpValue !== 'other' && dropOffValue === 'other' && <Col span={12}></Col>}
          {dropOffValue === 'other' && (
            <Col span={12}>
              <Form.Item
                name="drop_off_extra"
                className="form-item-name require"
                validateTrigger={['onChange', 'onBlur']}
              >
                <Input placeholder="Nhập điểm trả khác" size="large" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          )}
        </Row>
        {!listBooking?.schedule?.is_diagram ? (
          <Row className="w-100 mt-0">
            <Col span={3}>
              <Typography className="fs-16 fw-500 text-blue">Loại ghế:</Typography>{' '}
            </Col>
            <Col span={21}>
              <Form.Item name={'group_seat'} className="payment-checkbox-group group_seat">
                <Radio.Group options={groupSeatOption()} />
              </Form.Item>
            </Col>
          </Row>
        ) : (
          ''
        )}
      </div>

      <div className="payment-booking-block mt-4">
        <div className="bg-payment">
          <span>Thanh toán</span>
        </div>
        <Row gutter={20} className="w-100 mt-3">
          <Col span={6}>
            {(listBookingDetail?.payment_method !== 'agent_balance' &&
              listBookingDetail?.payment_method !== 'paid_at_company') ||
            group === USER_GROUP.AGENT ? (
              <Flex className={group !== USER_GROUP.AGENT ? `block-numpad-input` : ''}>
                <Form.Item name="total_price" label={t('Tổng tiền')} className="booking-input-disable price">
                  <InputNumber
                    suffix="VND"
                    disabled={
                      !pin_code || listBookingDetail?.source === 'openapi' || listBookingDetail?.source === 'company'
                    }
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value?.replace(/[^0-9]/g, '') as unknown as number}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(value) => {
                      formBooking.setFieldsValue({
                        commission_price_change: formattedPrice(value),
                      });
                    }}
                  />
                </Form.Item>
                {group !== USER_GROUP.AGENT &&
                  listBookingDetail?.source !== 'openapi' &&
                  listBookingDetail?.source !== 'company' && (
                    <div className="btn-numpad" onClick={() => handleNumpadClick(false)} style={{ marginTop: '26px' }}>
                      <img src={pin_code ? iconCancelPinCode : iconNumpad} alt="" />
                    </div>
                  )}
              </Flex>
            ) : (
              <>
                <Form.Item name="total_price1" label={t('Tổng tiền vé')} className="booking-input-disable price">
                  <Input suffix="VND" disabled />
                </Form.Item>
                {group !== USER_GROUP.AGENT &&
                  listBookingDetail?.status === 'reserve' &&
                  listBookingDetail?.source !== 'openapi' &&
                  listBookingDetail?.source !== 'company' && (
                    <div className="btn-numpad" onClick={() => handleNumpadClick(false)} style={{ marginTop: '25px' }}>
                      <img src={pin_code ? iconCancelPinCode : iconNumpad} alt="" />
                    </div>
                  )}
              </>
            )}
            {isInSurance && (
              <>
                {listBookingDetail?.ticket_code && listBookingDetail?.insurance_fee ? (
                  listBookingDetail?.price_change ? (
                    <Typography className="fs-14 fw-500 text-insurance">
                      {`Giá đã bao gồm ${formattedPrice(listBookingDetail?.insurance_fee)} đ tiền bảo hiểm`}
                    </Typography>
                  ) : (
                    <Typography className="fs-14 fw-500 text-insurance">
                      {`+${formattedPrice(listBookingDetail?.insurance_fee)} đ tiền bảo hiểm`}
                    </Typography>
                  )
                ) : (
                  <Typography className="fs-14 fw-500 text-insurance">
                    {listBooking?.policy?.insurance_policy?.percent
                      ? `+${listBooking?.policy?.insurance_policy?.percent}% tiền bảo hiểm`
                      : `+${formattedPrice(listBooking?.policy?.insurance_policy?.price)}đ tiền bảo hiểm`}
                  </Typography>
                )}
              </>
            )}
          </Col>
          {(listBookingDetail?.payment_method === 'agent_balance' && group !== USER_GROUP.AGENT) ||
          (group === USER_GROUP.AGENT && !listBookingDetail?.ticket_code) ||
          (!!listBookingDetail?.orderer?.agent?.id && !isAgentId && !agentId && group !== USER_GROUP.AGENT) ? (
            <Col span={6}>
              <Form.Item
                name="commission_price"
                label={t('Tổng tiền đại lý trả')}
                className="booking-input-disable price"
              >
                <Input suffix="VND" disabled className="input-h40 d-flex items-center border-r-2" />
              </Form.Item>
              {isDetail ? (
                <Typography className="fs-14 fw-500 text-discount">
                  {`Đã trừ ${
                    listBookingDetail?.agent_commission
                      ? listBookingDetail?.agent_commission
                      : listBookingDetail?.payer?.agent?.commission_percent
                      ? listBookingDetail?.payer?.agent?.commission_percent
                      : listBookingDetail?.orderer?.agent?.commission_percent ?? 0
                  }% chiết khấu`}
                </Typography>
              ) : (
                <Typography className="fs-14 fw-500 text-discount">
                  {`Đã trừ ${listBooking?.schedule?.agent?.commission_percent ?? 0}% chiết khấu`}
                </Typography>
              )}
            </Col>
          ) : (
            ''
          )}
          {isAgentId && agentId && commissionPrice !== 0 && (pin_code || listBookingDetail?.price_change) ? (
            <Col span={6}>
              22
              <Form.Item
                name={'commission_price_change'}
                label={t('Tổng tiền đại lý trả')}
                className="booking-input-disable price"
              >
                <InputNumber
                  suffix="VND"
                  disabled
                  onLoad={agentId}
                  onLoadedData={agentId}
                  className="input-h40 d-flex items-center border-r-2"
                />
              </Form.Item>
            </Col>
          ) : (
            ''
          )}

          {isAgentId && agentId && !pin_code && !listBookingDetail?.price_change ? (
            <Col span={6}>
              <Spin spinning={!commisionPrice && !isListTicket}>
                <Form.Item
                  name={'commission_price'}
                  label={t('Tổng tiền đại lý trả')}
                  className="booking-input-disable price"
                >
                  <InputNumber
                    suffix="VND"
                    disabled
                    onLoad={agentId}
                    parser={(value) => value?.replace(/[^0-9]/g, '') as unknown as number}
                    onLoadedData={agentId}
                    className="input-h40 d-flex items-center border-r-2"
                  />
                </Form.Item>
                {isDetail ? (
                  commissionPrice ? (
                    <Typography className="fs-14 fw-500 text-discount">{`Đã trừ ${
                      commissionPrice ?? 0
                    }% chiết khấu`}</Typography>
                  ) : (
                    <Typography className="fs-14 fw-500 text-discount">{`Đã trừ ${
                      listBookingDetail?.orderer?.agent?.commission_percent ?? 0
                    }% chiết khấu`}</Typography>
                  )
                ) : (
                  !pin_code &&
                  !listBookingDetail?.price_change && (
                    <Typography className="fs-14 fw-500 text-discount">{`Đã trừ ${
                      commissionPrice ?? 0
                    }% chiết khấu`}</Typography>
                  )
                )}
              </Spin>
            </Col>
          ) : (
            ''
          )}
          <Col
            span={
              ((listBookingDetail?.payment_method === 'agent_balance' || group === USER_GROUP.AGENT) &&
                !listBookingDetail?.price_change) ||
              (listBookingDetail?.orderer?.agent?.id && !pin_code && !listBookingDetail?.price_change) ||
              (isAgentId &&
                agentId &&
                !pin_code &&
                !listBookingDetail?.price_change &&
                listBookingDetail?.source !== 'openapi' &&
                listBookingDetail?.source !== 'company') ||
              ((pin_code || listBookingDetail?.price_change) && agentId && isAgentId)
                ? 12
                : 18
            }
          >
            <Form.Item name="note" label={t('Ghi chú')}>
              <Input placeholder="Nhập ghi chú" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col span={24}>
            {listBookingDetail?.source === 'openapi' || listBookingDetail?.source === 'company' ? (
              <div className="mt-1">
                {listBookingDetail?.status === 'paid' ? (
                  <Typography className="fs-16 text-green fw-500">Đã thanh toán cho Carlink API</Typography>
                ) : (
                  <Typography className="fs-16 reserve fw-500">Vé đang chờ khách thanh toán cho Carlink API</Typography>
                )}
              </div>
            ) : (
              <Form.Item
                name="payment_method"
                label={t('Phương thức thanh toán')}
                className="require mt-2"
                required={true}
              >
                <Radio.Group
                  options={options}
                  onChange={onChangePayment}
                  value={paymentMethod}
                  buttonStyle="solid"
                  className={`payment-checkbox-group mt-1`}
                />
              </Form.Item>
            )}
          </Col>
        </Row>
      </div>
      <Divider style={{ margin: '12px 0', height: 0 }} />
      <div>
        {listBookingDetail?.status === 'reserve' ? (
          <p className="fs-14 fw-500 text-blue pb-3">{`Người đặt: ${listBookingDetail?.orderer?.name}`}</p>
        ) : (
          ''
        )}
      </div>
      {/* <p>{list}</p> */}
      <div>
        {listBookingDetail?.status === 'paid' ? <>{getPayerBooking()}</> : ''}
        {listBookingDetail?.price_schedule ? (
          <p className="pb-3 fs-14 fw-500" style={{ color: '#3b82f6' }}>
            {getPriceScheduleReason(listBookingDetail?.price_schedule, false)}
          </p>
        ) : (
          ''
        )}
      </div>

      <ModalNumpad
        modalOpen={openModalNumpad}
        onCancel={() => {
          setOpenModalNumpad(false);
          setOtp('');
        }}
        onOk={() => false}
        otp={otp}
        setOtp={setOtp}
        isChangeSegment={isChangeSegment}
      />
      <ModalInfoInsurance
        modalOpen={openModalInfo}
        onCancel={() => setOpenModalInfo(false)}
        onOk={() => false}
        listBooking={listBooking}
        dataPolicy={dataCustomerBooking?.policy?.insurance_policy}
      />
    </Spin>
  );
};
export default ModalBooking1;
